// extracted by mini-css-extract-plugin
export default {"iconWrapper":"recipe_iconWrapper__Sctlz","icon":"recipe_icon__jqyaY","status":"recipe_status__32GdY","Active":"recipe_Active__syNAW","Inactive":"recipe_Inactive__nDQtO"};